module.exports = __webpack_public_path__ + "static/img/new_hotel.15eef47.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/clientes/new_hotel.png
// module id = H3Zl
// module chunks = 1